(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cf-balancer-price-gate"] && !Shopify.designMode) return;
  try {
    (() => {
  const initPriceGate = (gate) => {
    if (gate.dataset.cfPriceGateReady === 'true') return;
    gate.dataset.cfPriceGateReady = 'true';

    const productSection = gate.closest('.js-product');
    if (!productSection) return;

    const priceBlock = productSection.querySelector('[data-cf-balancer-live-price]');
    const purchaseBlock = productSection.querySelector('[data-cf-balancer-purchase-controls]');
    const bulkQuote = productSection.querySelector('[data-cf-balancer-bulk-quote]');

    const update = (variant) => {
      const hasLivePrice = Boolean(variant && Number(variant.price) > 0);
      gate.hidden = hasLivePrice;
      if (priceBlock) priceBlock.hidden = !hasLivePrice;
      if (purchaseBlock) purchaseBlock.hidden = !hasLivePrice;
      if (bulkQuote) bulkQuote.hidden = !hasLivePrice;
    };

    update({ price: Number(gate.dataset.currentPrice || 0) });

    productSection.addEventListener('on:variant:change', (event) => {
      update(event.detail.variant);
    });
  };

  const initAllPriceGates = () => {
    document.querySelectorAll('[data-cf-balancer-price-gate]').forEach(initPriceGate);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllPriceGates, { once: true });
  } else {
    initAllPriceGates();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cf-package-purchase"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-cf-bundle-button]');
  if (!button) return;

  const root = button.closest('[data-cf-package-purchase]');
  if (!root || button.disabled) return;

  const status = root.querySelector('[data-cf-bundle-status]');
  const form = button.closest('form[action*="/cart/add"]') || document.querySelector('.js-product-form-main');
  const variantInput = form ? form.querySelector('input[name="id"]') : null;
  const mainVariant = Number(variantInput?.value || root.dataset.mainVariant);
  const packageVariants = [...root.querySelectorAll('[data-cf-bundle-variant]')]
    .map((item) => Number(item.dataset.cfBundleVariant))
    .filter(Boolean);

  if (!mainVariant || packageVariants.length === 0) return;

  const originalText = button.textContent;
  button.disabled = true;
  button.textContent = root.dataset.adding;
  if (status) status.textContent = '';

  const items = [
    { id: mainVariant, quantity: 1 },
    ...packageVariants.map((id) => ({ id, quantity: 1 }))
  ];

  try {
    const shopRoot = window.Shopify?.routes?.root || '/';
    const response = await fetch(shopRoot + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items })
    });

    if (!response.ok) throw new Error('bundle-add-failed');
    window.location.href = shopRoot + 'cart';
  } catch (error) {
    if (status) status.textContent = root.dataset.error;
    button.disabled = false;
    button.textContent = originalText;
  }
});
  } catch(e) { console.error(e); }
})();

})();
